export default __webpack_public_path__ + "static/media/voltmeter.a9c5b8a4.svg";